export const contactFields = [
  {
    id: 'firstName',
    name: 'fname',
    label: 'First name',
    errorMessage: 'You must enter first name',
    autoComplete: 'given-name',
    required: true,
  },
  {
    id: 'lastName',
    name: 'lname',
    label: 'Last name',
    errorMessage: 'You must enter last name',
    autoComplete: 'family-name',
    required: true,
  },
  {
    id: 'phone',
    name: 'phone',
    label: 'Phone number',
    errorMessage: 'You must enter valid phone number',
    autoComplete: 'tel-national',
    required: true,
    type: 'tel',
  },
  {
    id: 'email',
    name: 'email',
    label: 'Email address',
    errorMessage: 'You must enter valid email that you own',
    autoComplete: 'email',
    required: true,
    type: 'email',
  },
];

export const successMessage = 'Your information has been updated successfully';



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/uiHelpers.js